<template>
    <div class="container">
        <v-title :lineage="[{'Automations':'automations'}]">
            Rules Engine
        </v-title>
        <v-form-tile>
            <h2 slot="title">Rules Engine</h2>
            <div slot="description">
                <p class="text-muted stack-m">Rather than adapt your workflow and business, Rebilly can align with your business objectives by giving you the power to automate certain behaviors when key events happen.</p>
                <p class="text-muted"> You can use this to your advantage to mitigate risk, maximize conversions and minimize costs. You have the controls at your fingertips here. If you need more control, or help dialing in on a strategy, feel free to contact us.</p>
            </div>
            <div slot="content" class="tile">
                <div class="tile-content">
                    <div class="grid-fitted">
                        <div class="grid-item grid-item-full" v-if="$auth.systemEvents.read.isAllowed">
                            <div class="settings-item" v-push="{name: 'system-events'}">
                                <div class="avatar avatar-description">
                                    <div class="avatar-image">
                                        <div class="avatar-icon">
                                            <v-icon icon="event"/>
                                        </div>
                                    </div>
                                    <div class="avatar-info"><p>System Events</p>
                                        <p class="text-muted">Manage rules and binds to be triggered by Rebilly's system events.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="grid-item grid-item-full" v-if="$auth.lists.read.isAllowed">
                            <div class="settings-item" v-push="{name: 'value-lists'}">
                                <div class="avatar avatar-description">
                                    <div class="avatar-image">
                                        <div class="avatar-icon">
                                            <v-icon icon="list"/>
                                        </div>
                                    </div>
                                    <div class="avatar-info"><p>Value Lists</p>
                                        <p class="text-muted">Create lists of common values to use within your rules or binds.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </v-form-tile>
    </div>
</template>

<script>
    import vTitle from '@/components/v-title';
    import {vFormTile, vIcon} from '@/components/form';

    export default {
        name: 'rules-engine',
        components: {
            vTitle, vIcon, vFormTile,
        },
    };
</script>
